import React from "react";
import "./contact.css";

function ContactUs() {
  return (
    <div className="contact-container">
      <h1 className="contact-heading">CONTACT</h1>
      <div className="contact-content">
        <div className="contact-form-section">
          <h2>Contact Us For Any Queries!</h2>
          <form>
            <input type="text" placeholder="Your Name" />
            <input type="email" placeholder="Enter Your Email" />
            <input type="text" placeholder="Your Mobile" />
            <select>
              <option>How Did You Hear About Us</option>
              <option>Social Media</option>
              <option>Friends</option>
              <option>Techers</option>
              <option>Others</option>
            </select>
            <textarea placeholder="Your Message"></textarea>
            <button type="submit">Submit Now</button>
          </form>
          <p>Follow us on Social Media!</p>
          <div className="social-icons">
            <i className="fab fa-facebook"></i>
            <i className="fab fa-linkedin"></i>
            <i className="fab fa-instagram"></i>
            <i className="fab fa-whatsapp"></i>
            <i className="fab fa-telegram"></i>
            <i className="fab fa-youtube"></i>
          </div>
        </div>
        <div className="explore-section">
          <h2>Explore our app!</h2>
          <p>
            Develop and enhance skills with tailored programs and resources.
            Benefit from structured schedules, detailed progress tracking, and
            personalized feedback for consistent learning.
          </p>
          <img
            src='/Assests/QR_CODE.png'
            alt="QR Code"
            className="qr-code"
          />
          <p>Scan the QR code to download the app</p>
          <button className="google-play-btn">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
          </button>
          <ul>
            <li>Exciting Features</li>
            <li>Improved User Interface</li>
            <li>Free Study Materials</li>
            <li>Kids Activity</li>
            <li>And much more!</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
